import { render } from "./Property.vue?vue&type=template&id=2c223d94&scoped=true"
import script from "./Property.vue?vue&type=script&lang=js"
export * from "./Property.vue?vue&type=script&lang=js"

import "./Property.vue?vue&type=style&index=0&id=2c223d94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c223d94"]])

export default __exports__